import React, { useState } from "react";
import PageBanner from './../Common/PageBanner'
import NavbarStyleFour from "../_App/NavbarStyleFour";
import Footer from "../_App/Footer";
import { LuAlertTriangle } from "react-icons/lu";
import { GoCheckCircleFill } from "react-icons/go";

const PayDues = () => {
  // UI States
  const [fetchStatus, setFetchStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successAlert, setSuccessAlert] = useState(false);

  // Search & Results States
  const [searchInput, setSearchInput] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  // Form fields state (Now Read-Only)
  const [orderData, setOrderData] = useState({
    orderId: '',
    startDate: '',
    service: '',
    serviceType: '',
    endDate: '',
    orderValue: '',
    advance: '',
    balance: '',
    customerName: ''
  });

  const [paymentType, setPaymentType] = useState('full');
  const [showTextBox, setShowTextBox] = useState(false);
  const [partialAmount, setPartialAmount] = useState('');

  const handleFetchData = async () => {
    if (!searchInput.trim()) {
      alert("Please enter Name, Email, Phone, or Order ID");
      return;
    }

    setLoading(true);
    setError(null);
    setFetchStatus(false);
    setSearchResults([]);

    try {
      const response = await fetch(`https://api-zspzr757qa-uc.a.run.app/orders`);
      const allOrders = await response.json();
      const search = searchInput.toLowerCase().trim();

      const matches = allOrders.filter(item =>
        item.orderId?.toLowerCase().includes(search) ||
        item.customerName?.toLowerCase().includes(search) ||
        item.email?.toLowerCase().includes(search) ||
        item.phone?.toString().includes(search)
      );

      if (matches.length > 1) {
        setSearchResults(matches);
      } else if (matches.length === 1) {
        selectOrder(matches[0]);
      } else {
        setError("No record found matching your search criteria.");
      }
    } catch (err) {
      setError("Connection to server failed.");
    } finally {
      setLoading(false);
    }
  };

  const selectOrder = (data) => {
    setOrderData(data);
    setSearchResults([]);
    setFetchStatus(true);
    setError(null);
    setSuccessAlert(true);
    // Auto-hide success alert after 3 seconds
    setTimeout(() => setSuccessAlert(false), 3000);
  };

  const handlePaymentTypeChange = (type) => {
    setPaymentType(type);
    setShowTextBox(type === 'part');
    if (type === 'full') setPartialAmount('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const amountToPay = paymentType === 'full' ? orderData.balance : partialAmount;
    
    if (!amountToPay || amountToPay <= 0) {
      alert("Please enter a valid payment amount.");
      return;
    }
    
    console.log(`Processing payment of ${amountToPay} for Order ${orderData.orderId}`);
    // Next step: API call to update the balance
  };

  return (
    <>
      <NavbarStyleFour />
      <PageBanner pageTitle={'Pay Dues'} />
      
      <div className="checkout-area ptb-80">
        <div className="container">
          <div className="billing-details">
            <h3 className="title">Billing Details</h3>
            
            <div className="row">
              <div className="col-lg-12">
                {/* Search Section */}
                <div className="d-flex align-items-end mb-4">
                  <div className="flex-grow-1">
                    <label className="fw-bold">Search Order Record</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Please Enter Name, Email, Phone or Order ID"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleFetchData()}
                    />
                  </div>
                  <button className="btn btn-primary ms-3" onClick={handleFetchData} disabled={loading} style={{ height: '50px' }}>
                    {loading ? 'Searching...' : 'Get Data'}
                  </button>
                </div>

                {/* Selection List for Multiple Results */}
                {searchResults.length > 0 && (
                  <div className="card mb-4 border-info">
                    <div className="card-header bg-info text-white">All Orders Found</div>
                    <div className="list-group list-group-flush">
                      {searchResults.map((item, index) => (
                        <button key={index} className="list-group-item list-group-item-action" onClick={() => selectOrder(item)}>
                          <strong>{item.customerName}</strong> | {item.service} | <span className="text-danger">Due: ₹{item.balance}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {error && <div className="alert alert-warning text-center">{error}</div>}

                {/* Read-Only Form Display */}
                {fetchStatus && (
                  <form onSubmit={handleSubmit}>
                    <div className="p-4 mb-4 bg-light border rounded">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0 text-primary">Order Verification</h5>
                        <span className=" badge w-auto p-2 m-3 text-warning fs-auto  bg-secondary">CustomerName: {orderData.customerName}</span>
                      </div>

                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="small text-muted">Order ID</label>
                          <input type="text" className="form-control-plaintext fw-bold border-bottom" value={orderData.orderId} readOnly />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="small text-muted">Service</label>
                          <input type="text" className="form-control-plaintext fw-bold border-bottom" value={orderData.service} readOnly />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="small text-muted">Service Type</label>
                          <input type="text" className="form-control-plaintext fw-bold border-bottom" value={orderData.serviceType} readOnly />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="small text-muted">Start Date</label>
                          <input type="text" className="form-control-plaintext fw-bold border-bottom" value={orderData.startDate} readOnly />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="small text-muted">End Date</label>
                          <input type="text" className="form-control-plaintext fw-bold border-bottom" value={orderData.endDate} readOnly />
                        </div>
                      </div>

                      <div className="row mt-4 p-3 bg-white rounded shadow-sm">
                        <div className="col-md-4 text-center">
                          <div className="small text-muted">Total Value</div>
                          <h4 className="mb-0">₹{orderData.orderValue}</h4>
                        </div>
                        <div className="col-md-4 text-center border-start border-end">
                          <div className="small text-muted">Total Paid</div>
                          <h4 className="mb-0 text-success">₹{orderData.advance}</h4>
                        </div>
                        <div className="col-md-4 text-center">
                          <div className="small text-muted">Current Balance</div>
                          <h4 className="mb-0 text-danger">₹{orderData.balance}</h4>
                        </div>
                      </div>
                    </div>

                    {/* Active Payment Section */}
                    <div className="payment-area p-4 border border-primary rounded">
                      <h5 className="mb-3">Select Payment Amount</h5>
                      <div className="d-flex flex-wrap align-items-center mb-4">
                        <div className="form-check me-4">
                          <input className="form-check-input" type="radio" name="payType" id="full" checked={paymentType === 'full'} onChange={() => handlePaymentTypeChange('full')} />
                          <label className="form-check-label" htmlFor="full">Pay Full Balance (₹{orderData.balance})</label>
                        </div>
                        <div className="form-check d-flex align-items-center">
                          <input className="form-check-input" type="radio" name="payType" id="part" checked={paymentType === 'part'} onChange={() => handlePaymentTypeChange('part')} />
                          <label className="form-check-label ms-2 me-3" htmlFor="part">Part of Payment</label>
                          {showTextBox && (
                            <input 
                              type="number" 
                              className="form-control form-control-sm" 
                              placeholder="Amount" 
                              style={{ width: '120px' }} 
                              value={partialAmount}
                              onChange={(e) => setPartialAmount(e.target.value)}
                            />
                          )}
                        </div>
                      </div>
                      <button type="submit" className="btn btn-success w-100 py-3 fw-bold">PROCEED TO SECURE PAYMENT</button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PayDues;